import { render, staticRenderFns } from "./DodatniSadrzaji.vue?vue&type=template&id=ce7a6e86&scoped=true&"
import script from "./DodatniSadrzaji.vue?vue&type=script&lang=js&"
export * from "./DodatniSadrzaji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7a6e86",
  null
  
)

export default component.exports